import { render, staticRenderFns } from "./getOrderLists.vue?vue&type=template&id=efc864ac&scoped=true&"
import script from "./getOrderLists.vue?vue&type=script&lang=js&"
export * from "./getOrderLists.vue?vue&type=script&lang=js&"
import style0 from "./getOrderLists.vue?vue&type=style&index=0&id=efc864ac&scoped=true&lang=css&"
import style1 from "./getOrderLists.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc864ac",
  null
  
)

export default component.exports